import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import {SnackbarState} from '~/redux/reducers/SnackbarReducer';

export const selectSnackbar = ({snackbar}: GlobalApplicationState): SnackbarState => snackbar;
